import { Button, Modal, VisuallyHidden } from '@farol-ds/react'
import { sendMetrics } from '@jusbrasil-web/shared-utils-events'

import { useModalContext } from '../context'
import { OneClickSuccess } from '../one-click-success/one-click-success'
import styles from './modal-success.module.scss'

export function ModalSuccess() {
  const { isSuccessModalOpen, closeSuccessModal, oneClickSuccessData } = useModalContext()

  function handleBackToContent() {
    const pid = oneClickSuccessData?.lockEventProperties?.pid?.toString()
    const { presentationName, priceText, frequency, frequencyInDays } =
      oneClickSuccessData?.offer || {}
    sendMetrics('UserAccount.OneClickSuccessBackToContent', pid, {
      app_id: oneClickSuccessData?.lockEventProperties?.app_id,
      from_component: oneClickSuccessData?.lockEventProperties?.from_component,
      modal_type: oneClickSuccessData?.lockEventProperties?.modal_type,
      metadata: {
        presentationName,
        priceText,
        frequency,
        frequencyInDays,
      },
    })
    closeSuccessModal()
  }

  if (!isSuccessModalOpen) {
    return null
  }

  return (
    <Modal size="md" open={isSuccessModalOpen} onOpenChange={handleBackToContent}>
      <Modal.Content data-testid="modal-success-content">
        <>
          <Modal.IconClose data-testid="modal-success-icon-close" />

          <Modal.Header data-testid="modal-success-header">
            <Modal.HeaderBrand data-testid="modal-success-header-brand" />
          </Modal.Header>
        </>
        <VisuallyHidden>
          <Modal.HeaderTitle>Assinatura realizada com sucesso</Modal.HeaderTitle>
        </VisuallyHidden>
        <Modal.Body data-testid="modal-success-body" className={styles.modalBody}>
          <OneClickSuccess />
        </Modal.Body>
        <Modal.Footer data-testid="modal-success-footer">
          <Button kind="primary" onClick={handleBackToContent}>
            Voltar ao conteúdo
          </Button>
        </Modal.Footer>
      </Modal.Content>
    </Modal>
  )
}
